import styled from 'styled-components'

import theme from 'theme_'

export const MyAccountPageWrap = styled.div`
  margin-top: ${theme.spacing.lg};
  padding: 0 20px;

  @media ${theme.devices.desktop} {
    padding: 0 40px;
  }
`
export const StyledAccountContainer = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.base};
  margin-top: ${theme.spacing.md};
  padding-bottom: 100px;
`
